export const LANGUAGE_MODAL = 'languageModal';
